"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaxonomiesQuery = void 0;
var models_1 = require("../../models");
var base_taxonomy_query_class_1 = require("./base-taxonomy-query.class");
var TaxonomiesQuery = /** @class */ (function (_super) {
    __extends(TaxonomiesQuery, _super);
    function TaxonomiesQuery(config, queryService) {
        var _this = _super.call(this, config, queryService) || this;
        _this.config = config;
        _this.queryService = queryService;
        return _this;
    }
    /**
    * Limits the number of taxonomies returned by query
    * @param limit Number of taxonomies to load
    */
    TaxonomiesQuery.prototype.limitParameter = function (limit) {
        this.parameters.push(new models_1.Parameters.LimitParameter(limit));
        return this;
    };
    /**
    * Skips the selected number of taxonomies
    * @param skip Number of taxonomies to skip
    */
    TaxonomiesQuery.prototype.skipParameter = function (skip) {
        this.parameters.push(new models_1.Parameters.SkipParameter(skip));
        return this;
    };
    /**
    * Gets the runnable Observable
    */
    TaxonomiesQuery.prototype.toObservable = function () {
        return _super.prototype.runTaxonomiesQuery.call(this);
    };
    // debug
    /**
    * Gets 'Url' representation of query
    */
    TaxonomiesQuery.prototype.getUrl = function () {
        return _super.prototype.getTaxonomiesQueryUrl.call(this);
    };
    return TaxonomiesQuery;
}(base_taxonomy_query_class_1.BaseTaxonomyQuery));
exports.TaxonomiesQuery = TaxonomiesQuery;
//# sourceMappingURL=taxonomies-query.class.js.map